
<div class="results-card"> 
    
      <div class="my-content-container">

        <mat-toolbar color="primary" class="results-toolbar">

          <button mat-raised-button (click)="addNew('create_attachment')" class="last right search-menu-button custom-button blue" color="primary">
            <mat-icon class="icon">file_upload</mat-icon>
          </button>

        </mat-toolbar>

      <table mat-table *ngIf="dataSource && !isLoading" [dataSource]="dataSource" class="mat-elevation-z8">
        <br>
  
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let element">
            {{element.name}} </td>
        </ng-container>
  
        <!-- Title Column -->
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>Title</th>
          <td mat-cell *matCellDef="let element">
            {{element.title}}
          </td>
        </ng-container>

        <!-- Description Column -->
        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let element">
              {{element.description}}
            </td>
          </ng-container>
          
        <!-- actions -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell width ="40px" *matHeaderCellDef> </th>
          <td mat-cell width ="40px" *matCellDef="let element">
  
            <!-- pdf list actions menu-->
            <button class="user_menu custom" mat-raised-button [mat-menu-trigger-for]="menu" fxHide="false" fxHide.gt-sm>
              <mat-icon>expand_more</mat-icon>
            </button>
  
            <mat-menu class="menu" x-position="before" #menu="matMenu">
              <button mat-menu-item (click)="editDetails(element)">
              <mat-icon>edit</mat-icon>
                  Edit 
              </button>            
              <button mat-menu-item (click)="preview(element)">
                <mat-icon>preview</mat-icon>
                  View 
              </button>                 
              <button mat-menu-item (click)="confirmation('delete', element)">
                  <mat-icon>delete</mat-icon>
                  Delete
              </button>

            </mat-menu>
  
        </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>


      <div class="no-results" *ngIf="noResults && !isLoading">
        <h1>No results</h1>
      </div>
      <mat-spinner *ngIf="isLoading"></mat-spinner>
      <br>
    </div>
  

  </div>
  